import { collection, query, getDocs, orderBy } from "firebase/firestore";
import { db } from "../../firebase";
import { getFunctions, httpsCallable } from "firebase/functions";
import { useEffect, useState } from "react";
import { app } from "../../firebase";
import "./css/UsuariosPendientes.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { mostrarError, mostrarExito } from "../../utils/Alertas";
import { hideLoading, showLoading } from "../../../redux/actions/loadingActions";
import { useDispatch } from "react-redux";

const UsuariosPendientes = () => {
    const [usuarios, setUsuarios] = useState<any[]>([]);
    const functions = getFunctions(app, "us-central1");
    const [openMenuId, setOpenMenuId] = useState<string | null>(null);
    const dispatch = useDispatch();

    const approveUser = httpsCallable(functions, "approveUser");
    const rejectUser = httpsCallable(functions, "rejectUser");
    const deleteUser = httpsCallable(functions, "deleteUser");

    const toggleMenu = (id: string) => {
        setOpenMenuId((prev) => (prev === id ? null : id));
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    useEffect(() => {
        const close = () => setOpenMenuId(null);
        window.addEventListener("click", close);
        return () => window.removeEventListener("click", close);
    }, []);

    const fetchUsers = async () => {
        const q = query(
            collection(db, "usuarios"),
            orderBy("fechaRegistro", "desc"),
        );

        const snap = await getDocs(q);

        setUsuarios(
            snap.docs.map((d) => ({
                id: d.id,
                ...d.data(),
            })),
        );
    };

    const handleDeleteUser = async (uid: string) => {
        dispatch(showLoading());

        try {
            await deleteUser({ uid });

            mostrarExito("Usuario eliminado correctamente");
            fetchUsers();
        } catch (err: any) {
            const code = err?.code;

            switch (code) {
                case "functions/unauthenticated":
                    mostrarError("No autenticado.");
                    break;
                case "functions/permission-denied":
                    mostrarError("No autorizado.");
                    break;
                case "functions/failed-precondition":
                    mostrarError("No se puede eliminar este usuario.");
                    break;
                default:
                    console.error(err);
                    mostrarError("No se pudo eliminar el usuario.");
            }
        } finally {
            dispatch(hideLoading());
        }
    };

    const handleApproveUser = async (uid: string) => {
        dispatch(showLoading());

        try {
            await approveUser({ uid });

            mostrarExito("Usuario aprobado correctamente");
            fetchUsers();
        } catch (err: any) {
            const code = err?.code;

            switch (code) {
                case "functions/unauthenticated":
                    mostrarError("No autenticado.");
                    break;
                case "functions/permission-denied":
                    mostrarError("No autorizado.");
                    break;
                default:
                    console.error(err);
                    mostrarError("No se pudo aprobar el usuario.");
            }
        } finally {
            dispatch(hideLoading());
        }
    };

    const handleRejectUser = async (uid: string) => {
        dispatch(showLoading());

        try {
            await rejectUser({ uid });

            mostrarExito("Usuario rechazado");
            fetchUsers();
        } catch (err: any) {
            const code = err?.code;

            switch (code) {
                case "functions/unauthenticated":
                    mostrarError("No autenticado.");
                    break;
                case "functions/permission-denied":
                    mostrarError("No autorizado.");
                    break;
                default:
                    console.error(err);
                    mostrarError("No se pudo rechazar el usuario.");
            }
        } finally {
            dispatch(hideLoading());
        }
    };

    const getRowClass = (status: string) => {
        switch (status) {
            case "pending_review":
                return "row-pending";
            case "approved":
                return "row-approved";
            case "rejected":
                return "row-rejected";
            case "deleted":
                return "row-deleted";
            default:
                return "";
        }
    };

    const getStatusBadge = (status: string) => {
        switch (status) {
            case "pending_review":
                return (
                    <span className="badge-status badge-pending">
                        Pendiente
                    </span>
                );
            case "approved":
                return (
                    <span className="badge-status badge-approved">Activo</span>
                );
            case "rejected":
                return (
                    <span className="badge-status badge-rejected">
                        Rechazado
                    </span>
                );
            case "deleted":
                return (
                    <span className="badge-status badge-deleted">
                        Eliminado
                    </span>
                );
            default:
                return null;
        }
    };

    return (
        <div className="container-fluid">
            <div className="text-center">
                <h2 className="pb-3">Gestión de usuarios</h2>
            </div>

            <div className="container-fluid content pb-3">
                <table className="table table-users">
                    <thead>
                        <tr>
                            <th style={{ width: "100%" }}>Email</th>
                            <th style={{ width: "100px" }}></th>
                            <th style={{ width: "48px" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {usuarios.map((u) => (
                            <tr key={u.id} className={getRowClass(u.status)}>
                                <td className="col-email">{u.email}</td>
                                <td className="col-status">
                                    {getStatusBadge(u.status)}
                                </td>

                                <td className="col-actions">
                                    {u.status !== "deleted" && (
                                        <button
                                            className="btn btn-options p-0"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                toggleMenu(u.id);
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={faEllipsisVertical}
                                                className="icon-options"
                                            />
                                        </button>
                                    )}

                                    {openMenuId === u.id &&
                                        u.status !== "deleted" && (
                                            <div className="options-menu">
                                                {u.status ===
                                                    "pending_review" && (
                                                    <>
                                                        <button
                                                            className="options-item approve"
                                                            onClick={() =>
                                                                handleApproveUser(u.id)
                                                            }
                                                        >
                                                            Aprobar
                                                        </button>
                                                        <button
                                                            className="options-item reject"
                                                            onClick={() =>
                                                                handleRejectUser(u.id)
                                                            }
                                                        >
                                                            Rechazar
                                                        </button>
                                                    </>
                                                )}

                                                {u.status === "rejected" && (
                                                    <>
                                                        <button
                                                            className="options-item approve"
                                                            onClick={() => handleApproveUser(u.id)}
                                                        >
                                                            Aprobar
                                                        </button>

                                                        <button
                                                            className="options-item delete"
                                                            onClick={() => handleDeleteUser(u.id)}
                                                        >
                                                            Eliminar usuario
                                                        </button>
                                                    </>
                                                )}

                                                {u.status === "approved" && (
                                                    <button
                                                        className="options-item delete"
                                                        onClick={() =>
                                                            handleDeleteUser(
                                                                u.id,
                                                            )
                                                        }
                                                    >
                                                        Eliminar usuario
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default UsuariosPendientes;
